<template>
    <div class="box-dropdown" v-on-clickaway="clickAway">
        <div
            class="selected-box"
            v-on:click="selectedItemsOnClick"
        >
            <slot name="selected-item"></slot>
            <span class="toggle-icon">
                <i class="fas fa-sort-up"></i>
                <i class="fas fa-sort-down"></i>
            </span>
        </div>
        <div
            class="__dropdown"
            v-bind:class="{active: __isOpen, left: isDropdownLeftZero, right: !isDropdownLeftZero}"
            :style="dropDownStyleObject"
        >
            <div
                class="dropdown-content"
            >
                <slot name="dropdown" :closeDropdown="closeDropdown"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import { directive as onClickaway } from 'vue-clickaway';

    export default {
        directives: {
            onClickaway: onClickaway,
        },
        data() {
            return {
                _isOpen: false
            }
        },
        props: {
            bgColor: {
                type: String,
                default: "#fff"
            },
            isDropdownLeftZero: {
                type: Boolean,
                default: true
            },
            /**
             * if click away target is inside the providing class, drop will not close
             */
            noClosingElSelector: {
                type: String | [String],
                default: null
            },
            isOpen: {
                type: Boolean,
                default: undefined
            },
            right: {
                type: Number
            }
        },
        computed: {
            __noClosingElSelectors() {
                if(this.noClosingElSelector === null) return [];
                return Array.isArray(this.noClosingElSelector) ? this.noClosingElSelector : [this.noClosingElSelector];
            },
            __isOpen() {
                return this.$props.isOpen !== undefined ? this.$props.isOpen : this.$data._isOpen;
            },
            dropDownStyleObject() {
                const styleObject = {
                    backgroundColor: this.bgColor
                };
                if(this.isDropdownLeftZero) {
                    styleObject.left = 0
                }else {
                    styleObject.right = this.right !== undefined ? `${this.right}px` : '0';
                }
                return styleObject;
            }
        },
        methods: {
            selectedItemsOnClick(e) {
                this.$data._isOpen = true;
                this.$emit('update:is-open', true);
            },
            clickAway(e) {
                const result = this.__noClosingElSelectors.filter(selector => {
                    return $(e.target).closest(selector).length !== 0
                });
                if(this.__isOpen) {
                    this.$data._isOpen = result.length > 0;
                    this.$emit('update:is-open', result.length > 0);
                }
            },
            closeDropdown() {
                this.$data._isOpen = false;
                this.$emit('update:is-open', false);
            }
        },
        mounted() {

        }
    }
</script>

<style lang="stylus" type="text/stylus" scoped>
    .box-dropdown
        position: relative
        .selected-box
            display: flex
            align-items: center
            justify-content: space-between
            box-shadow: 2px 2px 4px rgba(0,0,0,.3)
            z-index: 0
            cursor: pointer
            .toggle-icon
                position: relative
                font-size: 24px
                margin: 0 5px
            .fa-sort-down
                position: absolute
                top: 0
                left: 0
        .__dropdown
            display: none
            position: absolute
            top: 0
            box-shadow: 2px 2px 4px rgba(0,0,0,.3)
            z-index: 1;
            padding: 10px 0
            @media (max-width: 840px)
                width: 100%
            &.left
                left: 0
            &.right
                right:0
            &.active
                display: block
            .dropdown-content
                width: 100%
                height: 100%
</style>

<style  lang="stylus" type="text/stylus">
    .box-dropdown
        .ps:hover > .ps__scrollbar-y-rail
            opacity 1
        .ps__scrollbar-y-rail
            background-color: #eee!important
            border-radius: 8px!important
            width: 15px!important
            right: 5px
            opacity: 1
         .ps__scrollbar-y
            border-radius: 8px!important
            width: 15px!important
            right: 0!important
</style>